import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function userReducer(state = initialState.user, action) {
  switch (action.type) {
    case types.LOADING_USER:
      return { ...state, status: "loading" };
    case types.CREATE_USER_SUCCESS:
      return { ...state, data: action.user, status: "succeeded" };
    case types.GET_USER_SUCCESS:
      return { ...state, data: action.user, status: "succeeded" };
    case types.API_USER_ERROR:
      return { ...state, status: "failed", error: action.error };
    default:
      return state;
  }
}
